export default (urlParameters) => {
  return {
    baseUrl: import.meta.env.VITE_LIFESTYLE_API_URL_PROD,
    mmrsApiUrl: import.meta.env.VITE_MAP_TILES_URL_CDN_PROD,
    storm_track_data_url: import.meta.env.VITE_STORM_TRACK_DATA_URL_PROD,
    storm_track_data_file: import.meta.env.VITE_STORM_TRACK_DATA_FILE_PROD,
    tempestRestApiUrl: import.meta.env.VITE_TEMPEST_REST_API_URL_PROD,
    tempestWSApiUrl: import.meta.env.VITE_TEMPEST_WEBSOCKET_API_URL_PROD,
    apiKey: import.meta.env.VITE_LIFESTYLE_API_KEY_STORM, // StormTrack Webviews use the Storm API Key[AKA: Event API key] to show all spots on the map.
    tempestApiKey: import.meta.env.VITE_TEMPEST_API_KEY_LIFESTYLE_WEBVIEWS,
    mrmsApiKey: import.meta.env.VITE_MAP_TILES_API_KEY_STORM
  }
}